module.exports = __webpack_public_path__ + "static/media/Before - B@2x.7b9fa8ee.jpg";